<template>
  <modal
    v-slot="{ data }"
    name="menu-unavailable-modal"
    modal-style="compact"
    :display-header-title="false"
  >
    <menu-unavailable :data="data" />
  </modal>
</template>


<script>
  import MenuUnavailable from './menu-unavailable/index.vue';

  export default {
    name: 'MenuUnavailableModal',

    components: {
      MenuUnavailable
    }
  };
</script>
